<template>
  <section>
    <h1 class="section-head">รายการคำสั่งซื้อ</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <button class="button" @click="init">Refresh</button>
          <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
        </div>
      </div>
      <div class="level-center">
        <div class="level-item">
            
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <router-link class="button is-info is-pulled-right" :to="('/order/add')" v-can="'add_order'">
              <i class="fas fa-clipboard-list"></i>เพิ่มคำสั่งซื้อ
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    
    <div>
      <b-table
        :data="filteredData"
        selectable @click="selected"
        :selected.sync="selectedItem"
        :hoverable="true"
        :loading="isTableLoading"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :narrowed="true"
        v-if="orders.length > 0 || isTableLoading"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="รหัส" width="150">
            <strong>
              {{ props.row.code }}
            </strong>
          </b-table-column>

          <b-table-column field="id" label="รหัสการจัดส่ง" width="150">
            <strong>
              {{ props.row.ship_code ? props.row.ship_code : "ยังไม่จัดส่ง"}}
            </strong>
          </b-table-column>

          <b-table-column field="name" label="Company">
              {{ props.row.company ? props.row.company : "ยังไม่ระบุ"}} {{ props.row.name ? " - "+props.row.name : ""}}
          </b-table-column>

          <b-table-column field="amount" label="จำนวน (รายการ)" width="130">
              {{ props.row.items.length }}
          </b-table-column>

          <b-table-column field="total_price" label="ราคารวม (บาท)" width="150">
              {{ props.row.total_price ? parseFloat(props.row.total_price).formatMoney(2):0 }} บาท
          </b-table-column>

          <b-table-column field="ship_status" label="สถานะการจัดส่ง" width="130">
            <span class="tag is-success" v-if="(props.row.ship_status == '1' ? true:false)">จัดส่งแล้ว</span>
            <span class="tag is-warning" v-if="(props.row.ship_status == '0' ? true:false)">รอการจัดส่ง</span>
          </b-table-column>

          <b-table-column field="payment_status" label="สถานะการชำระเงิน" width="150">
            <span class="tag is-success" v-if="(props.row.payment_status == '1' ? true:false)">ชำระแล้ว</span>
            <span class="tag is-danger" v-if="(props.row.payment_status == '0' ? true:false)">ยังไม่ชำระ</span>
          </b-table-column>
          
        </template>
      </b-table>
      <div class="notification has-text-centered" v-else>ไม่พบข้อมูล</div>
    </div>
  </section>
</template>

<script>
  import OrderModel from '@/model/order_model'
  import Const from '@/const/const'

  export default {
    data() {
      return {
        orders: [],
        isTableLoading: false,
        selectedItem: null,
        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      filteredData: function() {
        return this.orders.filter(order => {
          return (
                  (order.code && order.code.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (order.ship_code && order.ship_code.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (order.company && order.company.toLowerCase().includes(this.search_query.toLowerCase()))
                )
        })
      }
    },
    methods:{
      async init(){
        this.isTableLoading = true;
        this.orders = await OrderModel.get_order();
        this.isTableLoading = false;
      },
      selected(item) {
        if(!this.can("view_order|edit_order|delete_order|issue_receipt|issue_tax_invoice")){
          this.$buefy.toast.open('คุณไม่มีสิทธิ์ที่จะเข้าถึงส่วนนี้!');
          return;
        }
        if(this.lastSelected == item){
          let routeData = this.$router.resolve({ path: '/order/view/'+item.id });
          window.open(routeData.href, '_blank');
          //this.$router.push({ path: '/order/view/'+item.id })
        }
        this.lastSelected = item;
      }
    }

  }
</script>

<style scoped>
  .table-style {
    font-size: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Order/index.vue